export default {
    module: 'pages/case'
};
